import { z } from 'zod';

export const adminUsuarioCreateSchema = z.object({
  nome: z.string().min(1, 'Nome é obrigatório'),
  email: z.string().email('Email inválido'),
  username: z.string().min(1, 'Username é obrigatório'),
  senha: z.string().min(6, 'Senha deve ter pelo menos 6 caracteres'),
  ativo: z.boolean(),
});

export const adminUsuarioEditSchema = adminUsuarioCreateSchema.omit({ senha: true });

export type AdminUsuarioCreateFormValues = z.infer<typeof adminUsuarioCreateSchema>;
export type AdminUsuarioEditFormValues = z.infer<typeof adminUsuarioEditSchema>;
